export default __webpack_public_path__ + "static/media/icon-back.24256838.svg";